'use client';

import QueryLink from '@components/QueryLink';

export default function Pagination({
  pages,
  currentPage,
  query,
  pageParamName = 'page',
}: {
  pages: number[];
  currentPage: number;
  query: URLSearchParams;
  pageParamName?: string;
}) {
  let prevPage = 1;
  return (
    <nav>
      <ol className='m-4 flex flex-wrap items-end justify-center gap-2'>
        {pages.map((page) => {
          query.set(pageParamName, String(page));
          let divider =
            page > prevPage + 2 ? <span className='text-3xl'>...</span> : '';
          prevPage = page;
          return (
            <li className='flex items-baseline' key={'key' + page}>
              {divider}
              <QueryLink
                query={query.toString()}
                className={`m-1 ml-3 border border-white p-4 hover:bg-white hover:text-black ${
                  page === currentPage ? 'bg-white text-black' : 'text-white'
                }`}
              >
                {page}
              </QueryLink>
            </li>
          );
        })}
      </ol>
    </nav>
  );
}
